import { render, staticRenderFns } from "./vipUserAccount.vue?vue&type=template&id=04f7f431&scoped=true"
import script from "./vipUserAccount.vue?vue&type=script&lang=js"
export * from "./vipUserAccount.vue?vue&type=script&lang=js"
import style0 from "./vipUserAccount.vue?vue&type=style&index=0&id=04f7f431&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f7f431",
  null
  
)

export default component.exports